import moment from 'moment'

function getDateDiff (startDate, endDate, timeUnit = 'days') {
  const diff = moment(endDate).diff(startDate, timeUnit)
  if (!diff) return 1
  return diff
}

export { getDateDiff }
